import React from "react";
import AnalyticalServicesRedesign from "../redesign/AnalyticalServicesRedesign";

const AnalyticalServices = () => {
  return <AnalyticalServicesRedesign />;
};

export default AnalyticalServices;
